<mat-toolbar role="heading">
	@defer (on immediate) {
		<mat-toolbar-row class="header-content">
			<button mat-icon-button class="menu-button" [class.app-16]="(isXXSmallWindow | async)?.matches" [class.app-24]="!((isXXSmallWindow | async)?.matches)" (click)="drawer().toggle()" aria-label="Toggle sidenav">
				<mat-icon>menu</mat-icon>
			</button>
			<a [routerLink]="['/']" rel="bookmark" class="logo-home">
				<img ngSrc="/icons/icon-192x192.png" alt="home" width="64" height="64" priority>
			</a>
			<div class="spacer"></div>
			<button mat-icon-button aria-label="Search" class="header-button" [class.app-16]="(isXXSmallWindow | async)?.matches" [class.app-24]="!((isXXSmallWindow | async)?.matches)" (click)="toggleSearch()">
				<mat-icon>search</mat-icon>
			</button>
			@if (authenticationService.user(); as user) {
				<a class="header-button-container" aria-label="profile" [matMenuTriggerFor]="menuLogin">
					<button mat-icon-button class="header-button" [class.app-16]="(isXXSmallWindow | async)?.matches" [class.app-24]="!((isXXSmallWindow | async)?.matches)">
						<mat-icon aria-label="Profile">person</mat-icon>
					</button>
					@if (!(isXSmallWindow | async)?.matches) {<span class="app-12">{{user.firstName}}</span>}
					<mat-menu #menuLogin="matMenu">
						<mat-nav-list>
							<a mat-list-item [routerLink]="['/profile','account']" aria-label="profile" role="listitem">
								<span i18n="@@header-profile|My profile menu item">Mi perfil</span>
							</a>
							<a mat-list-item [routerLink]="['/profile','addresses']" aria-label="addresses" role="listitem">
								<span i18n="@@header-addresses|My addresses menu item">Mis direcciones</span>
							</a>
							<a mat-list-item [routerLink]="['/profile','orders']" aria-label="orders" role="listitem">
								<span i18n="@@header-orders|My orders menu item">Mis ordenes</span>
							</a>
							<a mat-list-item (click)="authenticationService.logout()" (keydown)="authenticationService.logout()" aria-label="login" role="listitem">
								<span matListItemTitle>Log out</span>
								<mat-icon matListItemIcon>logout</mat-icon>
							</a>
						</mat-nav-list>
					</mat-menu>
				</a>
			} @else {
				<a class="header-button-container" aria-label="login" [matMenuTriggerFor]="menuLogin">
					<button mat-icon-button class="header-button" [class.app-16]="(isXXSmallWindow | async)?.matches" [class.app-24]="!((isXXSmallWindow | async)?.matches)">
						<mat-icon aria-label="Login">person</mat-icon>
					</button>
					@if (!(isXSmallWindow | async)?.matches) {<span class="app-12" i18n="@@header-login-register|Login / Register link">Iniciar sesión / Registro</span>}
					<mat-menu #menuLogin="matMenu">
						<mat-nav-list>
							<a mat-list-item (click)="openLogin()" (keydown)="openLogin()" aria-label="login" role="listitem">
								<span>Log in</span>
							</a>
							<a mat-list-item (click)="openSignup()" (keydown)="openSignup()" aria-label="login" role="listitem">
								<span i18n="@@header-signup|Create account menu item">Crear cuenta</span>
							</a>
							<a mat-list-item (click)="openForgotPassword()" (keydown)="openForgotPassword()" aria-label="login" role="listitem">
								<span i18n="@@header-forgot-password|Recover password menu item">Recuperar contraseña</span>
							</a>
						</mat-nav-list>
					</mat-menu>
				</a>
			}
			@if (appService.cart(); as cart) {
				<a class="header-button-container no-decoration cart-button-container" aria-label="cart" [routerLink]="['/cart']">
					<button mat-icon-button class="header-button" [class.app-16]="(isXXSmallWindow | async)?.matches" [class.app-24]="!((isXXSmallWindow | async)?.matches)">
						<mat-icon aria-label="Cart" [matBadge]="appService.cartItemsCount()" matBadgeSize="large" matBadgePosition="above after" aria-hidden="false" class="header-button-icon">shopping_cart</mat-icon>
					</button>
					@if (!(isXSmallWindow | async)?.matches) {<span class="app-12" i18n="@@header-cart|Cart link label">Carrito</span>}
				</a>
			}
		</mat-toolbar-row>
	} @placeholder {
		<mat-toolbar-row>
			<a [routerLink]="['/']" rel="bookmark" class="visually-hidden">
				<img ngSrc="/icons/icon-192x192.png" alt="home" width="50" height="50" priority>
			</a>
		</mat-toolbar-row>
	}
</mat-toolbar>
<div #searchContainer class="search-autocomplete" (focusout)="focusoutSearch()" [hidden]="true">
	<mat-form-field class="search-autocomplete-form-field">
		<input #searchInputHeader #searchAutocompleteHeaderTrigger="matAutocompleteTrigger" type="search" i18n-placeholder="@@header-search-placeholder|Search input placeholder" placeholder="Búsqueda" aria-label="search" matInput [formControl]="search" [matAutocomplete]="searchAutocompleteHeader" (search)="navigateSearch(searchInputHeader.value);" appInputEmptyToNull autocomplete="off">
		<mat-icon matSuffix (click)="navigateSearch(searchInputHeader.value);" class="app-pointer">search</mat-icon>
	</mat-form-field>
	<mat-autocomplete class="search-autocomplete-panel" #searchAutocompleteHeader="matAutocomplete" [hideSingleSelectionIndicator]="true">
		@for (product of filteredProducts | async; track product.id; let i=$index) {
			@if (i!==0) {<mat-divider></mat-divider>}
			<mat-option [value]="product.name" class="search-option" [routerLink]="['/products',product.slug]">
				<div class="search-option-item search-option-thumb-container">
					<img [ngSrc]="product.pictures[0].small" fill [alt]="product.name" class="search-option-thumb">
				</div>
				<div class="search-option-text">
					<p class="search-option-item-name">{{product.name}}</p>
					<i class="search-option-item search-option-highlights app-12">{{product.searchHighlights}}</i>
				</div>
			</mat-option>
		}
	</mat-autocomplete>
</div>
@defer (on immediate) {
	@if (!(isXSmallWindow | async)?.matches) {
	<mat-toolbar>
		<mat-toolbar-row>
			<mat-nav-list class="menu-toolbar">
				<a [matMenuTriggerFor]="menuProducts" mat-list-item [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:false}" role="button">
					<span i18n="@@header-products|Products menu link">Productos</span>
					<mat-menu #menuProducts="matMenu">
						<mat-nav-list>
							<a mat-list-item [routerLink]="['/products']">
								<span class="app-14" i18n="@@header-all-products|All products menu item">Todos los productos</span>
							</a>
							@for (category of appService.productCategories(); track category.id) {
								<a mat-list-item [routerLink]="['/products']" [queryParams]="{category:category.slug}" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}">
									<span>{{category.label}}</span>
								</a>
							}
						</mat-nav-list>
					</mat-menu>
				</a>
				<mat-divider vertical class="menu-toolbar-divider"></mat-divider>
				<a mat-list-item [routerLink]="['/contact']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}">
					<span i18n="@@header-contact|Contact menu link">Contacto</span>
				</a>
				<mat-divider vertical class="menu-toolbar-divider"></mat-divider>
				<a mat-list-item [routerLink]="['/envios']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}">
					<span i18n="@@header-shipping-policy|Shipping policy menu link">Política de envíos</span>
				</a>
				<mat-divider vertical class="menu-toolbar-divider"></mat-divider>
				<a mat-list-item [routerLink]="['/blog']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}">
					<span i18n="@@header-blog|Blog menu link">Blog</span>
				</a>
			</mat-nav-list>
		</mat-toolbar-row>
	</mat-toolbar>
	}
} @placeholder {
	<mat-nav-list class="visually-hidden">
		<span i18n="@@header-products-placeholder|Products link (placeholder)">Productos</span>
		<mat-nav-list>
			<a mat-list-item [routerLink]="['/products']">
				<span i18n="@@header-all-products-placeholder|All products link (placeholder)">Todos los productos</span>
			</a>
			@for (category of appService.productCategories(); track category.id) {
				<a mat-list-item [routerLink]="['/products']" [queryParams]="{category:category.slug}">
					<span>{{category.label}}</span>
				</a>
			}
		</mat-nav-list>
		<a mat-list-item [routerLink]="['/contact']">
			<span i18n="@@header-contact-placeholder|Contact link (placeholder)">Contacto</span>
		</a>
		<a mat-list-item [routerLink]="['/envios']">
			<span i18n="@@header-shipping-policy-placeholder|Shipping policy link (placeholder)">Política de envíos</span>
		</a>
		<a mat-list-item [routerLink]="['/blog']">
			<span i18n="@@header-blog-placeholder|Blog link (placeholder)">Blog</span>
		</a>
	</mat-nav-list>
}

